<template>
  <div
    class="emojis-main-container d-flex position-relative justify-content-center"
    :class="customClass"
  >
    <emoji-picker @emoji="insert" :search="search">
      <div
        slot="emoji-invoker"
        slot-scope="{ events: { click: clickEvent } }"
        @click.stop="clickEvent"
      >
        <button type="button">&#128512;</button>
      </div>
      <div slot="emoji-picker" slot-scope="{ emojis, insert }" v-if="!disabled">
        <div class="emoji-picker-container position-absolute bg-white border rounded shadow">
          <div class="border p-2">
            <input
              class="border rounded w-100"
              type="text"
              placeholder="Search emoji"
              v-model="search"
            />
          </div>
          <div class="p-1">
            <div v-for="(emojiGroup, category) in emojis" :key="category">
              <h5>{{ category }}</h5>
              <div class="emoji-category-container">
                <span
                  v-for="(emoji, emojiName) in emojiGroup"
                  :key="emojiName"
                  @click="insert(emoji)"
                  :title="emojiName"
                  >{{ emoji }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </emoji-picker>
  </div>
</template>

<script>
import EmojiPicker from 'vue-emoji-picker';
export default {
  components: {
    EmojiPicker,
  },
  props: {
    input: String,
    customClass: String,
    onClick: {
      type: Function,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: '',
    };
  },
  methods: {
    insert(emoji) {
      this.onClick(emoji);
    },
  },
};
</script>

<style scoped lang="scss">
.emoji-picker-container {
  top: 0;
  bottom: 100%;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  flex-wrap: wrap;
  width: 200px;
  max-width: 200px;
  height: 220px;
  max-height: 220px;
  overflow: auto;
  justify-self: center;
  z-index: 10000;

  input {
    height: 24px;
  }

  .emoji-category-container {
    display: flex;
    flex-wrap: wrap;

    span {
      cursor: pointer;
    }
  }
}
.emojis-main-container {
  width: min-content;
  height: min-content;
  z-index: 310000000;

  button {
    background-color: #ffffff;
    border: none;
    outline: none;
  }
  button:hover {
    border-radius: 4px;
    border: 2px solid var(--color-main);
  }
}
</style>
